export const convertNanosecondTimestampToDate = (nanosecondTimestamp) => {
    // 1_000_000 nanoseconds in a millisecond
    const milliseconds = Number(nanosecondTimestamp.toString()) / 1_000_000;
    return new Date(milliseconds);
};
